// pages/SportsBMTI.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebase';
import { doc, updateDoc, getDoc } from 'firebase/firestore';

// APTI 질문 데이터 (운동 성향 분석용)
const APTI_QUESTIONS = [
  // 리더 기질 (L / F)
  {
    id: 1,
    question: "팀 훈련 중 예상치 못한 상황이 벌어졌을 때 나는...",
    answers: [
      { text: "일단 내가 조정해볼게라며 나선다", type: "L", emoji: "👑" },
      { text: "누군가가 조정할 때까지 상황을 관망한다", type: "F", emoji: "👀" }
    ]
  },
  {
    id: 2,
    question: "팀이 어수선할 때 나는...",
    answers: [
      { text: "흐름을 정리하거나 의견을 모으려고 한다", type: "L", emoji: "🎯" },
      { text: "나부터 조용히 제 할 일을 하며 분위기를 본다", type: "F", emoji: "🤫" }
    ]
  },
  {
    id: 3,
    question: "경기 전 작전회의 시간, 나는...",
    answers: [
      { text: "작전이나 전략에 의견을 낸다", type: "L", emoji: "💭" },
      { text: "이미 짜인 작전에 따라가는 게 편하다", type: "F", emoji: "📋" }
    ]
  },
  // 주도 성향 (A / R)
  {
    id: 4,
    question: "경기 시작 직후, 나는...",
    answers: [
      { text: "먼저 압박하거나 선제타격을 노린다", type: "A", emoji: "⚡" },
      { text: "상대의 스타일을 보고 대응 방식을 정한다", type: "R", emoji: "🛡️" }
    ]
  },
  {
    id: 5,
    question: "상대가 강한 팀일수록 나는...",
    answers: [
      { text: "더 적극적으로 도전해서 흐름을 가져오려 한다", type: "A", emoji: "🔥" },
      { text: "수비적으로 안정감을 주며 기회를 엿본다", type: "R", emoji: "🏰" }
    ]
  },
  {
    id: 6,
    question: "공이 내게 왔을 때 나는...",
    answers: [
      { text: "내가 플레이를 전개하려는 의지가 크다", type: "A", emoji: "🚀" },
      { text: "주변 상황을 먼저 보고 연결할지 결정한다", type: "R", emoji: "👁️" }
    ]
  },
  // 사고 방식 (T / I)
  {
    id: 7,
    question: "경기 중 내 머릿속엔...",
    answers: [
      { text: "포지션, 간격, 루트 같은 정보가 자동으로 떠오른다", type: "T", emoji: "📊" },
      { text: "감각대로 움직인다. 여기다! 싶은 순간에 뛴다", type: "I", emoji: "💫" }
    ]
  },
  {
    id: 8,
    question: "팀원이 결정적인 찬스를 날렸을 때, 나는...",
    answers: [
      { text: "왜 저기서 저걸 했을까? 하며 머릿속으로 몇 가지 다른 장면을 떠올린다", type: "T", emoji: "🤔" },
      { text: "다음엔 그냥 내가 간다 하고 몸이 먼저 반응한다", type: "I", emoji: "🏃" }
    ]
  },
  {
    id: 9,
    question: "경기 중 내가 계속 상대 페이스에 말릴 때, 나는...",
    answers: [
      { text: "잠시 흐름을 끊고 호흡을 가다듬거나 루틴을 되짚는다", type: "T", emoji: "⏸️" },
      { text: "분위기 반전을 위해 과감하게 뭔가 하나 시도해본다", type: "I", emoji: "💥" }
    ]
  },
  // 집중 스타일 (D / M)
  {
    id: 10,
    question: "내가 선호하는 움직임은...",
    answers: [
      { text: "정해진 내 구역이나 포지션 안에서 집중하는 것", type: "D", emoji: "🎯" },
      { text: "그때그때 빈 공간을 찾아 움직이는 것", type: "M", emoji: "🌊" }
    ]
  },
  {
    id: 11,
    question: "경기 중 공이 내 구역에서 멀리 있을 때, 나는...",
    answers: [
      { text: "내 자리에서 상황을 지켜보며 준비 태세를 유지한다", type: "D", emoji: "🗿" },
      { text: "빈 공간이 생기면 자연스럽게 이동해 참여하려 한다", type: "M", emoji: "🦋" }
    ]
  },
  {
    id: 12,
    question: "공이 빠르게 반대편으로 전개됐을 때 나는...",
    answers: [
      { text: "내 위치에서 다음 수비/공격을 대비하며 대기한다", type: "D", emoji: "⚓" },
      { text: "빈 공간을 향해 달려가며 연결할 타이밍을 노린다", type: "M", emoji: "🏃‍♂️" }
    ]
  }
];

// APTI 결과 유형별 분석 (16가지)
const APTI_RESULTS = {
  LATD: {
    title: "판짜기 프로",
    subtitle: "Strategic Coordinator",
    description: "팀 전체의 구도를 설계하고 조율하는 리더형. 포지션 유지와 전술적 사고에 강하며, 무리하지 않고도 팀에 안정감을 주는 스타일입니다.",
    keywords: ["설계자", "포지션 고수", "지휘 능력"],
    sports: ["축구 중앙 미드필더", "농구 포인트 가드", "배구 세터"],
    strengths: ["전략 수립", "팀 조율", "포지션 감각", "안정감"],
    matchType: "FAIM",
    matchDescription: "감각적 연결 플레이를 펼치는 자유로운 공격수와 완벽한 호흡",
    tips: [
      "변화에 유연하게 대처하는 즉흥성도 가끔 필요합니다",
      "팀원 의견도 가끔은 내려놓고 경청해보세요",
      "전술적 완벽함과 실전 적응력의 균형을 찾아보세요"
    ],
    color: "#667eea",
    icon: "🎯"
  },
  LATM: {
    title: "전술 마에스트로", 
    subtitle: "Tactical Maestro",
    description: "위치를 바꿔가며 팀 흐름을 지휘하는 스타일. 전략적 위치 선정과 패턴 플레이에 능숙하며, 전방 압박과 빌드업 조율을 동시에 수행합니다.",
    keywords: ["유기적 움직임", "전략적 압박", "전방 주도"],
    sports: ["농구 포인트 가드", "럭비 센터", "핸드볼 플레이메이커"],
    strengths: ["유기적 이동", "전술 이해", "게임 조율", "압박 능력"],
    matchType: "FRIM",
    matchDescription: "흐름을 읽고 유연하게 움직이는 후방 연결자와 시너지",
    tips: [
      "종종 과도한 설계보다 상황에 맡기는 여유가 필요합니다",
      "예측 불가능한 상황에 즉각 반응하는 연습도 중요합니다",
      "완벽한 전술보다 팀원의 자율성도 존중해보세요"
    ],
    color: "#4ecdc4",
    icon: "🎨"
  },
  LAID: {
    title: "즉결의 사자",
    subtitle: "Instant Striker",
    description: "찬스에서 주저 없이 돌파하는 본능적 판단력을 가진 타입. 순간 상황 판단이 빠르고, 강한 승부욕으로 중심 포지션에서 분위기를 바꾸는 에이스형입니다.",
    keywords: ["승부욕", "결정력", "몰입도"],
    sports: ["농구 클러치 득점자", "테니스 단식", "럭비 포워드"],
    strengths: ["순간 판단", "승부 근성", "집중력", "돌파력"],
    matchType: "FRTD",
    matchDescription: "조용히 자리를 지키며 든든히 받쳐주는 방패형 수비수와 완벽한 조합",
    tips: [
      "전체 흐름보다 자기 플레이에만 집중하지 않도록 주의하세요",
      "다른 사람의 템포도 함께 맞추는 훈련이 필요합니다",
      "개인기와 팀워크의 균형점을 찾아보세요"
    ],
    color: "#ff6b6b",
    icon: "🦁"
  },
  LAIM: {
    title: "플로우 메이커",
    subtitle: "Flow Maker", 
    description: "즉흥적인 센스로 경기 흐름을 바꾸는 창조형 리더. 연계 플레이에 강하며, 팀원들과 연결을 만들어내고 포지션을 넘나들며 상황에 맞춰 유연하게 대처합니다.",
    keywords: ["즉흥성", "연계 플레이", "공간 감각"],
    sports: ["배드민턴 복식", "농구 패스 중심 스몰 포워드", "축구 플레이메이커"],
    strengths: ["창의성", "연결 능력", "공간 인식", "유연성"],
    matchType: "FRTM",
    matchDescription: "수비와 공격을 유연하게 오가며 빈틈을 메우는 서포터와 호흡",
    tips: [
      "때로는 전략적인 플랜도 필요합니다",
      "지나친 자유 플레이는 팀 전술에 혼란을 줄 수 있습니다",
      "즉흥성과 규율성의 조화를 찾아보세요"
    ],
    color: "#f093fb",
    icon: "🌊"
  },
  LRTD: {
    title: "철벽 수비수",
    subtitle: "Iron Defender",
    description: "팀 수비의 중심을 잡고, 무너지지 않는 수비 라인을 책임지는 타입. 포지션을 단단히 지키며 안정감을 주고, 경기 상황에 맞춰 후방 조율과 방어를 담당합니다.",
    keywords: ["안정감", "포지션 고수", "수비 리더"],
    sports: ["축구 센터백", "야구 포수", "농구 파워 포워드"],
    strengths: ["수비 안정", "포지션 감각", "리더십", "집중력"],
    matchType: "FAIM",
    matchDescription: "공격을 이끄는 창의적인 전방 플레이어와 완벽한 균형",
    tips: [
      "너무 경직되지 말고 유연한 대처 연습이 필요합니다",
      "가끔은 공격적인 움직임도 시도해보세요",
      "완벽한 수비와 유연한 대응의 균형을 찾아보세요"
    ],
    color: "#96ceb4",
    icon: "🛡️"
  },
  LRTM: {
    title: "플로우 코디네이터",
    subtitle: "Flow Coordinator",
    description: "팀 수비와 공격 사이의 연결고리 역할을 하며, 유기적인 움직임으로 경기 흐름을 부드럽게 이어가는 타입. 상대 움직임에 민첩하게 반응하며 포지션을 유연하게 조정합니다.",
    keywords: ["유연성", "경기 조율", "연결 플레이"],
    sports: ["축구 윙백", "농구 슈팅 가드", "배구 리베로"],
    strengths: ["유기적 이동", "상황 판단", "연결 능력", "적응력"],
    matchType: "FATD",
    matchDescription: "공격을 주도하는 창의적 플레이어와 시너지",
    tips: [
      "때로는 수비 집중력이 떨어질 수 있으니 주의하세요",
      "팀 전술과 조율을 놓치지 않도록 신경 써주세요",
      "유연함과 일관성의 밸런스를 찾아보세요"
    ],
    color: "#45b7d1",
    icon: "🔗"
  },
  LRID: {
    title: "본능의 수비수",
    subtitle: "Instinct Guardian",
    description: "순간적인 직감과 감각으로 후방을 든든히 지키며, 상대 공격을 예측하고 빠르게 대응하는 스타일. 유연한 움직임으로 수비 라인의 균형을 맞춥니다.",
    keywords: ["본능", "직감", "유연성"],
    sports: ["축구 센터백", "농구 스몰 포워드", "테니스 수비형"],
    strengths: ["직감", "반응속도", "유연성", "예측력"],
    matchType: "FAIM",
    matchDescription: "창의적이고 공격적인 전방 플레이어와 완벽한 조합",
    tips: [
      "순간 판단에 의존하다가 전략적인 계획을 잊을 수 있습니다",
      "팀과의 소통과 전술 이해도 신경 써주세요",
      "본능과 계획성의 조화를 찾아보세요"
    ],
    color: "#a8e6cf",
    icon: "🐾"
  },
  LRIM: {
    title: "즉흥의 수호자",
    subtitle: "Improv Guardian",
    description: "순간적인 센스와 유연한 움직임으로 후방을 지키며, 팀의 흐름을 자연스럽게 연결하는 창조적 수비수. 상황에 맞춰 즉흥적으로 대응하고 공간을 메우는 능력이 뛰어납니다.",
    keywords: ["즉흥성", "유연성", "공간 감각"],
    sports: ["축구 풀백", "농구 슈팅 가드", "배구 유틸리티"],
    strengths: ["즉흥 대응", "공간 인식", "창의성", "연결 능력"],
    matchType: "FATM",
    matchDescription: "감각적으로 흐름을 만드는 공격형 리더와 완벽한 호흡",
    tips: [
      "즉흥성이 지나치면 전술 혼란을 초래할 수 있습니다",
      "팀 전술에 대한 이해와 소통이 중요합니다",
      "창의성과 규율의 균형을 찾아보세요"
    ],
    color: "#ffd93d",
    icon: "🎭"
  },
  FATD: {
    title: "작전형 돌격수",
    subtitle: "Tactical Striker",
    description: "코치의 지시나 팀의 전략에 충실하면서도 본인의 역할에 몰입해서 찬스를 놓치지 않는 공격수. 지정된 루트, 세트 플레이, 위치 플레이에 특히 강합니다.",
    keywords: ["전술 수행력", "집중력", "침투형 플레이"],
    sports: ["축구 윙어/스트라이커", "배구 라이트 공격수", "럭비 윙 포워드"],
    strengths: ["전술 이해", "실행력", "집중력", "침투 능력"],
    matchType: "LRTD",
    matchDescription: "설계된 전략을 전방에서 실현해주는 플레이메이커와 시너지",
    tips: [
      "플랜 외 상황에서도 유연하게 대처할 수 있도록 감각을 키워보세요",
      "지시가 없을 때 당황하지 않도록 자기 판단력도 훈련하세요",
      "전술적 완벽함과 개인 창의성의 조화를 찾아보세요"
    ],
    color: "#74b9ff",
    icon: "⚔️"
  },
  FATM: {
    title: "센스형 조력자",
    subtitle: "Tactical Supporter",
    description: "팀 전략을 이해하고, 공격 흐름 속에서 빈틈을 메우는 센스가 뛰어난 스타일. 연결 플레이와 서브 포지션을 정확하게 수행하며 조용히 경기의 리듬을 만듭니다.",
    keywords: ["전술 이해도", "연결력", "조율 능력"],
    sports: ["배구 세터", "축구 중앙 미드필더", "농구 슈팅 가드"],
    strengths: ["전술 이해", "연결 능력", "조율 감각", "리듬 메이킹"],
    matchType: "LAIM",
    matchDescription: "창의적인 연결 리더와의 호흡이 찰떡",
    tips: [
      "본인 판단 없이 지시에만 의존하지 마세요",
      "공격 상황에서 결정력도 함께 키워보세요",
      "팀워크와 개인 주도성의 균형을 찾아보세요"
    ],
    color: "#00b894",
    icon: "🤝"
  },
  FAID: {
    title: "감각형 피니셔",
    subtitle: "Instinct Finisher",
    description: "복잡한 지시 없이도 본능적으로 기회를 잡는 결정력 높은 공격수. 기민한 위치 선정과 순간적인 돌파가 특기이며, 찬스 메이킹에 탁월한 능력을 보입니다.",
    keywords: ["감각", "돌파", "찬스 포착"],
    sports: ["축구 스트라이커", "농구 스몰 포워드", "야구 4번 타자"],
    strengths: ["직감", "돌파력", "기회 포착", "결정력"],
    matchType: "LRTD",
    matchDescription: "수비의 안정감을 기반으로 본능적 공격 전개",
    tips: [
      "순간 감각에만 의존하다가 전술 흐름을 놓칠 수 있습니다",
      "전체 맥락도 고려하는 연습이 필요합니다",
      "본능과 전략의 조화를 찾아보세요"
    ],
    color: "#fd79a8",
    icon: "⚡"
  },
  FAIM: {
    title: "자유로운 찬스메이커",
    subtitle: "Free Chance Maker",
    description: "포지션에 얽매이지 않고 공간을 창조하며 흐름을 깨는 스타일. 경기 내내 자유롭게 움직이며 찬스를 만들고 연결 플레이를 유도합니다.",
    keywords: ["창의성", "공간 감각", "즉흥성"],
    sports: ["농구 스윙맨", "축구 세컨드 스트라이커", "배드민턴 더블스"],
    strengths: ["창의성", "공간 창조", "즉흥성", "연결 능력"],
    matchType: "LATD",
    matchDescription: "전술 중심의 리더와 시너지가 뛰어남",
    tips: [
      "자유로운 플레이가 때론 팀 전술에 혼란을 줄 수 있습니다",
      "필요한 순간에는 규율도 지켜야 합니다",
      "자유로움과 팀워크의 균형을 찾아보세요"
    ],
    color: "#fdcb6e",
    icon: "🦋"
  },
  FRTD: {
    title: "전술형 수비수",
    subtitle: "Tactical Defender",
    description: "수비 위치를 철저히 지키며 정확한 움직임과 판단으로 실수를 줄이는 스타일. 전체 라인을 조율하고, 조직적인 수비를 주도합니다.",
    keywords: ["안정감", "수비 리딩", "팀 전술 이해"],
    sports: ["축구 센터백", "농구 디펜시브 센터", "배구 미들 블로커"],
    strengths: ["수비 조직", "전술 이해", "안정성", "리더십"],
    matchType: "FAID",
    matchDescription: "감각적 공격수와 찰떡 호흡",
    tips: [
      "예측 불가능한 상황에 즉흥적 대응 능력도 키워야 합니다",
      "창의적 플레이어와의 호흡 맞추기 연습이 필요합니다",
      "완벽한 계획과 유연한 대응의 조화를 찾아보세요"
    ],
    color: "#6c5ce7",
    icon: "🏰"
  },
  FRTM: {
    title: "유연한 서포터",
    subtitle: "Flexible Supporter",
    description: "공격과 수비를 유연하게 넘나들며 빈 곳을 메워주는 연결자. 팀이 흔들릴 때 중심을 잡아주는 숨은 핵심 역할을 합니다.",
    keywords: ["밸런스", "흐름 유지", "위치 감각"],
    sports: ["축구 수비형 미드필더", "배구 서브 리시버", "농구 식스맨"],
    strengths: ["균형 감각", "적응력", "서포트", "안정성"],
    matchType: "LAIM",
    matchDescription: "감각적 리더의 움직임에 맞춰 균형을 잡아주는 파트너",
    tips: [
      "자기 주도성이 부족해질 수 있습니다",
      "적극적인 순간 판단 능력도 중요합니다",
      "서포트와 주도성의 균형을 찾아보세요"
    ],
    color: "#a29bfe",
    icon: "⚖️"
  },
  FRID: {
    title: "반사 신경 수비수",
    subtitle: "Reflex Defender",
    description: "상대 움직임에 민감하게 반응하여 기회를 사전에 차단하는 스타일. 1:1 대인 방어와 순간 스틸, 태클에 능하며 반사적 대응력이 뛰어납니다.",
    keywords: ["반사 신경", "대응력", "1:1 수비"],
    sports: ["축구 풀백", "농구 수비 전문 가드", "핸드볼 수비"],
    strengths: ["반응속도", "1:1 수비", "순간 판단", "대응력"],
    matchType: "LAID",
    matchDescription: "본능적인 공격수와 찰떡 호흡으로 균형 잡힘",
    tips: [
      "반응에만 의존하면 전체적인 경기 흐름을 놓칠 수 있습니다",
      "위치 선정과 포지셔닝도 함께 훈련해주세요",
      "반사적 대응과 전략적 사고의 조화를 찾아보세요"
    ],
    color: "#55a3ff",
    icon: "⚡"
  },
  FRIM: {
    title: "감각형 흐름 메이커",
    subtitle: "Instinct Flow Maker",
    description: "센스 있는 움직임으로 수비와 공격을 자연스럽게 연결하며 경기 흐름을 유도하는 타입. 포지션 이동에 능하고 빈 공간을 빠르게 채우는 능력이 뛰어납니다.",
    keywords: ["센스", "유연성", "흐름 연결"],
    sports: ["축구 윙백", "농구 스윙맨", "배구 유틸리티 플레이어"],
    strengths: ["센스", "흐름 조절", "유연성", "공간 인식"],
    matchType: "LATM",
    matchDescription: "자유롭게 흐름을 만드는 공격 리더와의 완벽한 호흡",
    tips: [
      "본능적 플레이가 많아지면 팀 전략과 멀어질 수 있습니다",
      "소통과 전술 이해도 중요합니다",
      "감각과 전략의 조화를 찾아보세요"
    ],
    color: "#26de81",
    icon: "🌪️"
  }
};

function ActivityPersonalityTest() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [result, setResult] = useState(null);
  const [isStarted, setIsStarted] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const userData = JSON.parse(storedUser);
      setUser(userData);
      // 기존 APTI 결과가 있는지 확인
      if (userData.aptiResult) {
        setResult(userData.aptiResult);
        setIsCompleted(true);
      }
    }
  }, []);

  const handleAnswer = (answerType) => {
    const newAnswers = [...answers, answerType];
    setAnswers(newAnswers);

    if (currentQuestion < APTI_QUESTIONS.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
      calculateResult(newAnswers);
    }
  };

  const calculateResult = (allAnswers) => {
    const counts = { L: 0, F: 0, A: 0, R: 0, T: 0, I: 0, D: 0, M: 0 };
    
    allAnswers.forEach(answer => {
      counts[answer]++;
    });

    const aptiType = 
      (counts.L > counts.F ? 'L' : 'F') +
      (counts.A > counts.R ? 'A' : 'R') +
      (counts.T > counts.I ? 'T' : 'I') +
      (counts.D > counts.M ? 'D' : 'M');

    const resultData = {
      type: aptiType,
      ...APTI_RESULTS[aptiType],
      completedAt: new Date().toISOString(),
      detailedScores: counts
    };

    setResult(resultData);
    setIsCompleted(true);
    saveResult(resultData);
  };

  const saveResult = async (resultData) => {
    if (!user) return;

    setLoading(true);
    try {
      // 사용자 데이터베이스에 MBTI 결과 저장 (sportsMBTI, APTI 둘 다)
      const userRef = doc(db, "users", user.docId || user.id);
      await updateDoc(userRef, {
        sportsMBTI: resultData,
        sportsMBTIUpdatedAt: new Date(),
        APTI: resultData // 추가: APTI 필드에도 저장
      });

      // 로컬 스토리지도 업데이트
      const updatedUser = { ...user, sportsMBTI: resultData, APTI: resultData };
      localStorage.setItem("user", JSON.stringify(updatedUser));
      setUser(updatedUser);

      console.log("MBTI 결과 저장 완료:", resultData);
    } catch (error) {
      console.error("MBTI 결과 저장 실패:", error);
      alert("결과 저장 중 오류가 발생했습니다. 다시 시도해주세요.");
    } finally {
      setLoading(false);
    }
  };

  const resetTest = () => {
    setCurrentQuestion(0);
    setAnswers([]);
    setResult(null);
    setIsStarted(false);
    setIsCompleted(false);
  };

  const progress = isStarted ? ((currentQuestion + 1) / APTI_QUESTIONS.length) * 100 : 0;

  // 로딩 상태
  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 20
      }}>
        <div style={{
          background: '#fff',
          borderRadius: 24,
          padding: 48,
          maxWidth: 400,
          width: '100%',
          textAlign: 'center',
          boxShadow: '0 20px 60px rgba(0,0,0,0.2)'
        }}>
          <div style={{
            width: 60,
            height: 60,
            border: '4px solid #f3f4f6',
            borderTop: '4px solid #667eea',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 24px auto'
          }}></div>
          <h2 style={{
            fontSize: 24,
            fontWeight: 700,
            color: '#1e293b',
            marginBottom: 12
          }}>
            결과를 저장하고 있습니다...
          </h2>
          <p style={{
            fontSize: 16,
            color: '#64748b'
          }}>
            잠시만 기다려주세요
          </p>
        </div>
      </div>
    );
  }

  // 시작 화면
  if (!isStarted && !isCompleted) {
    return (
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 20
      }}>
        <div style={{
          background: '#fff',
          borderRadius: 24,
          padding: 48,
          maxWidth: 600,
          width: '100%',
          textAlign: 'center',
          boxShadow: '0 20px 60px rgba(0,0,0,0.2)'
        }}>
          <div style={{
            fontSize: 80,
            marginBottom: 24,
            animation: 'bounce 2s infinite'
          }}>
            🏃‍♂️
          </div>
          
          <h1 style={{
            fontSize: 36,
            fontWeight: 800,
            color: '#1e293b',
            marginBottom: 16
          }}>
            APTI 테스트
          </h1>
          
          <p style={{
            fontSize: 20,
            color: '#667eea',
            fontWeight: 600,
            marginBottom: 12
          }}>
            Activity Personality Type Indicator
          </p>
          
          <p style={{
            fontSize: 18,
            color: '#64748b',
            marginBottom: 32,
            lineHeight: 1.6
          }}>
            당신의 운동 성향과 활동 스타일을 분석해드립니다.<br/>
            12가지 질문으로 나만의 스포츠 성격을 발견해보세요!
          </p>

          <div style={{
            background: '#f8fafc',
            borderRadius: 16,
            padding: 24,
            marginBottom: 32,
            border: '1px solid #e2e8f0'
          }}>
            <h3 style={{
              fontSize: 20,
              fontWeight: 700,
              color: '#1e293b',
              marginBottom: 16
            }}>
              📊 분석 영역
            </h3>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
              gap: 16,
              textAlign: 'left'
            }}>
              <div>
                <div style={{ fontSize: 24, marginBottom: 8 }}>👑</div>
                <div style={{ fontSize: 14, fontWeight: 600, color: '#374151' }}>리더 기질 (L/F)</div>
                <div style={{ fontSize: 12, color: '#6b7280' }}>Leader vs Follower</div>
              </div>
              <div>
                <div style={{ fontSize: 24, marginBottom: 8 }}>⚡</div>
                <div style={{ fontSize: 14, fontWeight: 600, color: '#374151' }}>주도 성향 (A/R)</div>
                <div style={{ fontSize: 12, color: '#6b7280' }}>Active vs Reactive</div>
              </div>
              <div>
                <div style={{ fontSize: 24, marginBottom: 8 }}>🧠</div>
                <div style={{ fontSize: 14, fontWeight: 600, color: '#374151' }}>사고 방식 (T/I)</div>
                <div style={{ fontSize: 12, color: '#6b7280' }}>Tactical vs Instinctive</div>
              </div>
              <div>
                <div style={{ fontSize: 24, marginBottom: 8 }}>🎯</div>
                <div style={{ fontSize: 14, fontWeight: 600, color: '#374151' }}>집중 스타일 (D/M)</div>
                <div style={{ fontSize: 12, color: '#6b7280' }}>Diver vs Mover</div>
              </div>
            </div>
          </div>

          <button
            onClick={() => setIsStarted(true)}
            style={{
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              border: 'none',
              borderRadius: 16,
              padding: '16px 32px',
              color: '#fff',
              fontSize: 18,
              fontWeight: 700,
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 8px 25px rgba(102, 126, 234, 0.4)'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-3px) scale(1.05)';
              e.target.style.boxShadow = '0 12px 35px rgba(102, 126, 234, 0.6)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0) scale(1)';
              e.target.style.boxShadow = '0 8px 25px rgba(102, 126, 234, 0.4)';
            }}
          >
            🚀 테스트 시작하기
          </button>

          <p style={{
            fontSize: 14,
            color: '#9ca3af',
            marginTop: 16
          }}>
            약 3-5분 소요 • 12개 질문
          </p>
        </div>

        <style>{`
          @keyframes bounce {
            0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
            40% { transform: translateY(-10px); }
            60% { transform: translateY(-5px); }
          }
          
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  // 질문 화면
  if (isStarted && !isCompleted) {
    const question = APTI_QUESTIONS[currentQuestion];
    
    return (
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 20
      }}>
        <div style={{
          background: '#fff',
          borderRadius: 24,
          padding: 40,
          maxWidth: 700,
          width: '100%',
          boxShadow: '0 20px 60px rgba(0,0,0,0.2)'
        }}>
          {/* 프로그레스 바 */}
          <div style={{
            marginBottom: 32
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: 12
            }}>
              <span style={{
                fontSize: 16,
                fontWeight: 600,
                color: '#64748b'
              }}>
                질문 {currentQuestion + 1} / {APTI_QUESTIONS.length}
              </span>
              <span style={{
                fontSize: 14,
                color: '#9ca3af'
              }}>
                {Math.round(progress)}% 완료
              </span>
            </div>
            <div style={{
              width: '100%',
              height: 8,
              background: '#e2e8f0',
              borderRadius: 4,
              overflow: 'hidden'
            }}>
              <div style={{
                width: `${progress}%`,
                height: '100%',
                background: 'linear-gradient(90deg, #667eea, #764ba2)',
                borderRadius: 4,
                transition: 'width 0.5s ease'
              }} />
            </div>
          </div>

          {/* 질문 */}
          <div style={{
            textAlign: 'center',
            marginBottom: 40
          }}>
            <h2 style={{
              fontSize: 28,
              fontWeight: 700,
              color: '#1e293b',
              marginBottom: 16,
              lineHeight: 1.3
            }}>
              {question.question}
            </h2>
            <p style={{
              fontSize: 16,
              color: '#64748b'
            }}>
              당신의 성향에 더 가까운 답변을 선택해주세요
            </p>
          </div>

          {/* 답변 선택지 */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 16
          }}>
            {question.answers.map((answer, index) => (
              <button
                key={index}
                onClick={() => handleAnswer(answer.type)}
                style={{
                  background: '#f8fafc',
                  border: '2px solid #e2e8f0',
                  borderRadius: 16,
                  padding: '20px 24px',
                  textAlign: 'left',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  fontSize: 16,
                  fontWeight: 500,
                  color: '#374151',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 16
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = '#f0f4ff';
                  e.target.style.borderColor = '#667eea';
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 8px 20px rgba(102, 126, 234, 0.2)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = '#f8fafc';
                  e.target.style.borderColor = '#e2e8f0';
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = 'none';
                }}
              >
                <div style={{
                  fontSize: 24,
                  width: 40,
                  textAlign: 'center'
                }}>
                  {answer.emoji}
                </div>
                <div style={{ flex: 1 }}>
                  {answer.text}
                </div>
                <div style={{
                  fontSize: 12,
                  color: '#9ca3af',
                  background: '#e2e8f0',
                  padding: '4px 8px',
                  borderRadius: 8,
                  fontWeight: 600
                }}>
                  {String.fromCharCode(65 + index)}
                </div>
              </button>
            ))}
          </div>

          {/* 하단 버튼 */}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: 32
          }}>
            <button
              onClick={() => {
                if (currentQuestion > 0) {
                  setCurrentQuestion(currentQuestion - 1);
                  setAnswers(answers.slice(0, -1));
                }
              }}
              disabled={currentQuestion === 0}
              style={{
                background: 'transparent',
                border: '1px solid #d1d5db',
                borderRadius: 8,
                padding: '8px 16px',
                color: currentQuestion === 0 ? '#9ca3af' : '#6b7280',
                fontSize: 14,
                cursor: currentQuestion === 0 ? 'not-allowed' : 'pointer',
                opacity: currentQuestion === 0 ? 0.5 : 1
              }}
            >
              ← 이전
            </button>

            <div style={{
              fontSize: 12,
              color: '#9ca3af',
              textAlign: 'center'
            }}>
              키보드 A, B로도 선택할 수 있습니다
            </div>

            <div style={{
              fontSize: 14,
              color: '#64748b',
              fontWeight: 500
            }}>
              {APTI_QUESTIONS.length - currentQuestion - 1}개 남음
            </div>
          </div>
        </div>
      </div>
    );
  }

  // 결과 화면
  if (isCompleted && result) {
    return (
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '40px 20px'
      }}>
        <div style={{
          maxWidth: 900,
          margin: '0 auto'
        }}>
          {/* 헤더 */}
          <div style={{
            textAlign: 'center',
            marginBottom: 40
          }}>
            <button
              onClick={() => navigate(-1)}
              style={{
                background: 'rgba(255,255,255,0.1)',
                border: '1px solid rgba(255,255,255,0.3)',
                borderRadius: 8,
                padding: '8px 16px',
                color: '#fff',
                fontSize: 14,
                cursor: 'pointer',
                marginBottom: 20,
                backdropFilter: 'blur(10px)'
              }}
            >
              ← 뒤로가기
            </button>
            
            <h1 style={{
              fontSize: 32,
              fontWeight: 800,
              color: '#fff',
              margin: '0 0 8px 0',
              textShadow: '0 2px 10px rgba(0,0,0,0.3)'
            }}>
              🎉 당신의 APTI 결과
            </h1>
            <p style={{
              fontSize: 16,
              color: 'rgba(255,255,255,0.9)',
              marginBottom: 8
            }}>
              Activity Personality Type Indicator
            </p>
            <p style={{
              fontSize: 14,
              color: 'rgba(255,255,255,0.7)'
            }}>
              운동 성향 분석이 완료되었습니다!
            </p>
          </div>

          {/* 메인 결과 카드 */}
          <div style={{
            background: '#fff',
            borderRadius: 24,
            padding: 40,
            marginBottom: 24,
            boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
            textAlign: 'center'
          }}>
            <div style={{
              fontSize: 80,
              marginBottom: 16
            }}>
              {result.icon}
            </div>
            
            <div style={{
              background: `linear-gradient(135deg, ${result.color}, ${result.color}90)`,
              color: '#fff',
              padding: '12px 24px',
              borderRadius: 20,
              fontSize: 18,
              fontWeight: 700,
              marginBottom: 16,
              display: 'inline-block'
            }}>
              {result.type}
            </div>
            
            <h2 style={{
              fontSize: 32,
              fontWeight: 800,
              color: '#1e293b',
              marginBottom: 8
            }}>
              {result.title}
            </h2>
            
            <p style={{
              fontSize: 18,
              color: result.color,
              fontWeight: 600,
              marginBottom: 20
            }}>
              {result.subtitle}
            </p>
            
            <p style={{
              fontSize: 16,
              color: '#64748b',
              lineHeight: 1.6,
              maxWidth: 700,
              margin: '0 auto'
            }}>
              {result.description}
            </p>
          </div>

          {/* 상세 분석 섹션 */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
            gap: 24,
            marginBottom: 24
          }}>
            {/* 키워드 & 추천 포지션 */}
            <div style={{
              background: '#fff',
              borderRadius: 20,
              padding: 24,
              boxShadow: '0 8px 25px rgba(0,0,0,0.1)'
            }}>
              <h3 style={{
                fontSize: 20,
                fontWeight: 700,
                color: '#1e293b',
                marginBottom: 16,
                display: 'flex',
                alignItems: 'center',
                gap: 8
              }}>
                🏃 추천 포지션
              </h3>
              <div style={{
                marginBottom: 16
              }}>
                {result.sports.map((sport, index) => (
                  <div
                    key={index}
                    style={{
                      background: `${result.color}15`,
                      color: result.color,
                      padding: '8px 12px',
                      borderRadius: 8,
                      fontSize: 14,
                      fontWeight: 600,
                      marginBottom: 8,
                      border: `1px solid ${result.color}30`
                    }}
                  >
                    {sport}
                  </div>
                ))}
              </div>
              
              <h4 style={{
                fontSize: 16,
                fontWeight: 600,
                color: '#374151',
                marginBottom: 8
              }}>
                핵심 키워드
              </h4>
              <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 8
              }}>
                {result.keywords.map((keyword, index) => (
                  <span
                    key={index}
                    style={{
                      background: '#f3f4f6',
                      color: '#6b7280',
                      padding: '4px 12px',
                      borderRadius: 12,
                      fontSize: 12,
                      fontWeight: 500
                    }}
                  >
                    {keyword}
                  </span>
                ))}
              </div>
            </div>

            {/* 강점 */}
            <div style={{
              background: '#fff',
              borderRadius: 20,
              padding: 24,
              boxShadow: '0 8px 25px rgba(0,0,0,0.1)'
            }}>
              <h3 style={{
                fontSize: 20,
                fontWeight: 700,
                color: '#1e293b',
                marginBottom: 16,
                display: 'flex',
                alignItems: 'center',
                gap: 8
              }}>
                💪 나의 강점
              </h3>
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, 1fr)',
                gap: 8
              }}>
                {result.strengths.map((strength, index) => (
                  <div
                    key={index}
                    style={{
                      background: '#f8fafc',
                      padding: '8px 12px',
                      borderRadius: 8,
                      fontSize: 14,
                      color: '#374151',
                      textAlign: 'center',
                      fontWeight: 500,
                      border: '1px solid #e2e8f0'
                    }}
                  >
                    {strength}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* 궁합 & 개선 팁 */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
            gap: 24,
            marginBottom: 24
          }}>
            {/* 최고 궁합 */}
            <div style={{
              background: '#fff',
              borderRadius: 20,
              padding: 24,
              boxShadow: '0 8px 25px rgba(0,0,0,0.1)'
            }}>
              <h3 style={{
                fontSize: 20,
                fontWeight: 700,
                color: '#1e293b',
                marginBottom: 16,
                display: 'flex',
                alignItems: 'center',
                gap: 8
              }}>
                💕 최고 궁합
              </h3>
              <div style={{
                background: `${result.color}10`,
                border: `2px solid ${result.color}30`,
                borderRadius: 12,
                padding: 16,
                marginBottom: 12
              }}>
                <div style={{
                  fontSize: 18,
                  fontWeight: 700,
                  color: result.color,
                  marginBottom: 8
                }}>
                  {result.matchType}
                </div>
                <p style={{
                  fontSize: 14,
                  color: '#374151',
                  margin: 0,
                  lineHeight: 1.4
                }}>
                  {result.matchDescription}
                </p>
              </div>
            </div>

            {/* 개선 팁 */}
            <div style={{
              background: '#fff',
              borderRadius: 20,
              padding: 24,
              boxShadow: '0 8px 25px rgba(0,0,0,0.1)'
            }}>
              <h3 style={{
                fontSize: 20,
                fontWeight: 700,
                color: '#1e293b',
                marginBottom: 16,
                display: 'flex',
                alignItems: 'center',
                gap: 8
              }}>
                💡 개선 팁
              </h3>
              <div style={{
                display: 'grid',
                gap: 12
              }}>
                {result.tips.map((tip, index) => (
                  <div
                    key={index}
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: 8,
                      padding: 12,
                      background: '#f8fafc',
                      borderRadius: 8,
                      border: '1px solid #e2e8f0'
                    }}
                  >
                    <div style={{
                      background: '#fbbf24',
                      color: '#fff',
                      width: 18,
                      height: 18,
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: 10,
                      fontWeight: 700,
                      flexShrink: 0,
                      marginTop: 1
                    }}>
                      {index + 1}
                    </div>
                    <p style={{
                      fontSize: 13,
                      color: '#374151',
                      margin: 0,
                      lineHeight: 1.4
                    }}>
                      {tip}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* 액션 버튼들 */}
          <div style={{
            display: 'flex',
            gap: 16,
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            <button
              onClick={resetTest}
              style={{
                background: 'rgba(255,255,255,0.1)',
                border: '2px solid rgba(255,255,255,0.3)',
                borderRadius: 16,
                padding: '14px 28px',
                color: '#fff',
                fontSize: 16,
                fontWeight: 600,
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                backdropFilter: 'blur(10px)'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'rgba(255,255,255,0.2)';
                e.target.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'rgba(255,255,255,0.1)';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              🔄 다시 테스트하기
            </button>

            <button
              onClick={() => {
                const myGuildId = localStorage.getItem('myGuildId');
                if (myGuildId) {
                  navigate(`/guild/${myGuildId}`);
                } else {
                  navigate('/guild');
                }
              }}
              style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                border: 'none',
                borderRadius: 16,
                padding: '14px 28px',
                color: '#fff',
                fontSize: 16,
                fontWeight: 700,
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 8px 25px rgba(102, 126, 234, 0.4)'
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-3px) scale(1.05)';
                e.target.style.boxShadow = '0 12px 35px rgba(102, 126, 234, 0.6)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0) scale(1)';
              }}
            >
              🏰 팀 가입하기
            </button>
          </div>
        </div>
        <div style={{ position: 'fixed', bottom: 24, left: '50%', transform: 'translateX(-50%)', zIndex: 9999 }}>
          <button onClick={() => window.location.href = '/'} style={{ padding: '16px 40px', borderRadius: 24, background: '#10b981', color: '#fff', fontWeight: 800, fontSize: 20, border: 'none', cursor: 'pointer', boxShadow: '0 4px 16px #10b98133', letterSpacing: 1 }}>
            홈 화면으로 이동
          </button>
        </div>
      </div>
    );
  }
}

export default ActivityPersonalityTest;